import { useEffect } from 'react'
import { consentGroups, getConsentedGroups } from '@dhl/onetrust'
import { type DatadogConfig, initDatadog, setDatadogTrackingConsent } from './datadog.js'

const getPerformanceConsent = (): 'granted' | 'not-granted' =>
  getConsentedGroups().includes(consentGroups.performance) ? 'granted' : 'not-granted'

export const useDatadog = (datadogConfig: DatadogConfig | undefined, isOneTrustLoaded: boolean): void => {
  useEffect(() => {
    if (datadogConfig) {
      initDatadog({
        ...datadogConfig,
        trackingConsent: getPerformanceConsent(),
      })
    }
  }, [datadogConfig])

  useEffect(() => {
    if (datadogConfig && isOneTrustLoaded) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- explicit OneTrust event type not available
      window.OneTrust?.OnConsentChanged?.((event: any) => {
        const consent = event.detail?.includes(consentGroups.performance) ? 'granted' : 'not-granted'
        setDatadogTrackingConsent(consent)
      })
    }
  }, [datadogConfig, isOneTrustLoaded])
}
